import apiClient from "../services/apiClient";
import CRC32 from 'crc-32';

/**
 * ----------------------------
 * DOCUMENT ENDPOINTS
 * ----------------------------
 */

export const generateUploadUrl = async (payload) => {
  try {
    const res = await apiClient.post("/documents/upload-url", payload);
    return res.data;
  } catch (err) {
    console.error("Error generating upload URL:", err.response?.data || err.message);
    throw err;
  }
};

export const uploadFileToS3 = async (uploadUrl, file, onProgress, signal) => {
  try {
    console.log('File:', { name: file.name, type: file.type, size: file.size });
    console.log('Upload URL:', uploadUrl);

    const response = await apiClient.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type || 'application/octet-stream',
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      },
      signal,
    });
    return response.data;
  } catch (err) {
    console.error("S3 Error Response:", {
      message: err.message,
      response: err.response?.data,
      status: err.response?.status,
      headers: err.response?.headers,
      url: uploadUrl,
      contentType: file.type || 'application/octet-stream',
    });
    throw err;
  }
};


export const uploadDocument = async (payload) => {
  try {
    const res = await apiClient.post("/documents", payload);
    return res.data;
  } catch (err) {
    console.error("Error saving document metadata:", err.response?.data || err.message);
    throw err;
  }
};

export const getDocuments = async (entityType, entityId) => {
  try {
    const res = await apiClient.get(`/documents/${entityType}/${entityId}`);
    return res.data;
  } catch (err) {
    console.error("Error fetching documents:", err.response?.data || err.message);
    throw err;
  }
};

export const deleteDocument = async (documentId) => {
  try {
    const res = await apiClient.delete(`/documents/${documentId}`);
    return res.data;
  } catch (err) {
    console.error("Error deleting document:", err.response?.data || err.message);
    throw err;
  }
};

/**
 * ----------------------------
 * TASK REPORT ENDPOINTS
 * ----------------------------
 */

export const createTaskReport = async (payload) => {
  try {
    const res = await apiClient.post("/task-reports", payload);
    return res.data;
  } catch (err) {
    console.error("Error creating task report:", err.response?.data || err.message);
    throw err;
  }
};

export const getTaskReportsByStaff = async (staffId) => {
  try {
    const res = await apiClient.get(`/task-reports/staff/${staffId}`);
    return res.data;
  } catch (err) {
    console.error("Error fetching task reports for staff:", err.response?.data || err.message);
    throw err;
  }
};

export const getAllTaskReports = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.staffId) queryParams.append('staffId', filters.staffId);
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/task-reports/all?${queryString}` : '/task-reports/all';
    
    const res = await apiClient.get(url);
    return res.data;
  } catch (err) {
    console.error("Error fetching all task reports:", err.response?.data || err.message);
    throw err;
  }
};

export const getTaskReportByTaskId = async (taskId) => {
  try {
    const res = await apiClient.get(`/task-reports/task/${taskId}`);
    return res.data;
  } catch (err) {
    console.error("Error fetching task report by task ID:", err.response?.data || err.message);
    throw err;
  }
};

export const getTaskReportById = async (reportId) => {
  try {
    const res = await apiClient.get(`/task-reports/${reportId}`);
    return res.data;
  } catch (err) {
    console.error("Error fetching task report:", err.response?.data || err.message);
    throw err;
  }
};

export const updateTaskReport = async (reportId, payload) => {
  try {
    const res = await apiClient.patch(`/task-reports/${reportId}`, payload);
    return res.data;
  } catch (err) {
    console.error("Error updating task report:", err.response?.data || err.message);
    throw err;
  }
};

export const updateTaskReportStatus = async (reportId, statusData) => {
  try {
    const res = await apiClient.patch(`/task-reports/${reportId}/status`, statusData);
    return res.data;
  } catch (err) {
    console.error("Error updating task report status:", err.response?.data || err.message);
    throw err;
  }
};

export const deleteTaskReport = async (reportId) => {
  try {
    const res = await apiClient.delete(`/task-reports/${reportId}`);
    return res.data;
  } catch (err) {
    console.error("Error deleting task report:", err.response?.data || err.message);
    throw err;
  }
};